import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Button, Spinner, Form, OverlayTrigger, Tooltip } from "react-bootstrap";

import Card from "../../components/Card";
import TransaksiService from "../../services/transaksi/TransaksiService";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { FaBars, FaEye, FaMinus, FaPlus, FaPrint, FaTrash } from "react-icons/fa";
import StatusDok from "../../utilities/StatusDok";
import JenisKomoditi from "../../utilities/JenisKomoditi";
import { formatDateTimeLocalDate } from "../../utilities/Utils";
import ExpandableComponentTugas from "./expand/ExpandableComponentTugas";
import Negara from "../../utilities/Negara";
import ModalCetakPermohonan from "./modals/ModalCetakPermohonan";
import ModalLog from "./modals/ModalLog";
import SweetAlert from "react-bootstrap-sweetalert";
// import MasterService from "../../services/master/MasterService";
// import { AsyncPaginate } from "react-select-async-paginate";

const DaftarSetujuDraft = () => {
    const columns = [
        {
            name: 'Nomor Aju',
            cell: row => row['nomorAju'],
            grow: 0.75
        },
        {
            name: 'Tanggal Aju',
            cell: row => formatDateTimeLocalDate(row['tanggalAju']),
            grow: 0.5
        },
        {
            name: 'NPWP',
            cell: row => row['npwpTrader']
        },
        {
            name: 'Nama',
            cell: row => row['namaTrader']
        },
        {
            name: 'Tujuan',
            cell: row => <Negara id={row['negaraPartner']} />,
            grow: 0.5
        },
        {
            name: 'Jenis Komoditi',
            cell: row => <JenisKomoditi id={row['jenisKomoditi']} />,
            grow: 0.5
        },
        {
            name: 'Peruntukan',
            cell: row => row['peruntukan'] === '1' ? 'Konsumsi' : 'Non Konsumsi',
            grow: 0.5
        },
        {
            name: 'Status',
            cell: row => <StatusDok kodeStatus={row['status']} />,
            grow: 0.5
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className="row">
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Cetak Permohonan</Tooltip>}>
                                <Button size="sm" variant="success" onClick={() => CetakPermohonan(row)}>
                                    <FaPrint /> Cetak
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat Permohonan</Tooltip>}>
                                <Button size="sm" variant="info" onClick={() => ViewDok(row['nomorAju'], '0')}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Hapus Permohonan</Tooltip>}>
                                <Button size="sm" variant="danger" onClick={() => HapusDok(row)}>
                                    <FaTrash /> Hapus
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >History Permohonan</Tooltip>}>
                                <Button size="sm" variant="secondary" onClick={() => ViewLogStatus(row)}>
                                    <FaBars /> History
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                    </div>
                </>
            ),
            grow: 0.5
        },
    ]

    let transaksiService = useMemo(() => new TransaksiService(), [])
    // let masterService = useMemo(() => new MasterService(), [])

    const [listPpm, setListPpm] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getListPpm = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const responDraftApprov = await transaksiService.listPpmPerUpt(null, null, localStorage.getItem('kdUnit'), '028', page, size)

            setListPpm(responDraftApprov.data.data)
            setTotalData(responDraftApprov.data.totalData)
        } catch (error) {
            console.log(error)
            setListPpm([])
        }
        setLoading(false)
    }, [transaksiService])

    useEffect(() => {
        getListPpm(0, 10)
    }, [getListPpm])

    const handleChangePage = (page) => {
        getListPpm(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const responDraftApprov = await transaksiService.listPpmPerUpt(null, null, localStorage.getItem('kdUnit'), '028', page - 1, size)

        setListPpm(responDraftApprov.data.data)
        setSize(size)
    }

    const navigate = useNavigate();

    const ViewDok = (noAju, isEdit) => {
        localStorage.removeItem('isEditStorage')
        localStorage.removeItem('nomorAjuStorage')
        localStorage.setItem('nomorAjuStorage', noAju)
        localStorage.setItem('isEditStorage', isEdit)
        navigate('/permohonan/ekspor/view-2')
    }

    const [showConfirmHapus, setShowConfirmHapus] = useState(false)
    const handleCloseConfirmHapus = () => setShowConfirmHapus(false)
    const [showHapusSuccess, setShowHapusSucces] = useState(false)
    const [showHapusFailed, setShowHapusFailed] = useState(false)
    const [loadingHapus, setLoadingHapus] = useState(false)

    const HapusDok = (rowdata) => {
        setShowConfirmHapus(true)
        setRowData(rowdata)
    }

    const handleClickHapus = async () => {
        setLoadingHapus(true)
        try {
            let jsonHapusData = { ...rowData, status: '120' }

            const response = await transaksiService.addPpm(JSON.stringify(jsonHapusData))
            if (response.data.kode === '200') {
                setShowHapusSucces(true)
                setShowConfirmHapus(false)
            } else {
                setShowHapusFailed(true)
            }
        } catch (error) {
            setShowHapusFailed(true)
        }
        setLoadingHapus(false)
    }

    const handleClickHapusSuccess = () => {
        setShowHapusSucces(false)
        getListPpm(0, 10)
    }

    const handleClickHapusFailed = () => {
        setShowHapusFailed(false)
    }

    const [showLog, setShowLog] = useState(false)
    const handleCloseLog = () => setShowLog(false)

    const ViewLogStatus = (rowdata) => {
        setRowData(rowdata)
        setShowLog(true)
    }

    const [rowData, setRowData] = useState(null)
    const [showCetak, setShowCetak] = useState(false)
    const handleCloseCetak = () => setShowCetak(false)

    const CetakPermohonan = (rowdata) => {
        setRowData(rowdata)
        setShowCetak(true)
    }

    const handleClickCari = async (page, size) => {
        const _res = await transaksiService.listPpmPerUpt(valueSearchAju, null, localStorage.getItem('kdUnit'), '028', page, size)
        setListPpm(_res.data.data)
        setSize(size)
    }

    const [valueSearchAju, setValueSearchAju] = useState('')
    const onChangeSearchAju = e => {
        setValueSearchAju(e.target.value)
    }

    // const [valueSearchEks, setValueSearchEks] = useState('')
    // const onChangeSearchEks = e => {
    //     setValueSearchEks(e.target.value)
    // }

    // const [valueStatusOpt, setValueStatusOpt] = useState(null)
    // async function loadOptionStatus(search, loadedOption, { page = 1 }) {
    //     const response = await masterService.listStatusDok(search, page - 1, 10)
    //     return {
    //         options: response.data.data,
    //         hasMore: response.data.data.length >= 10,
    //         additional: {
    //             page: page + 1
    //         }
    //     }
    // }
    // const onChangeStatus = e => {
    //     setValueStatusOpt(e)
    // }

    // const [valueNegaraOpt, setValueNegaraOpt] = useState(null)
    // async function loadOptionNegara(search, loadedOption, { page = 1 }) {
    //     const response = await masterService.listNegara(search, page - 1, 10)
    //     return {
    //         options: response.data.data,
    //         hasMore: response.data.data.length >= 10,
    //         additional: {
    //             page: page + 1
    //         }
    //     }
    // }
    // const onChangeNegara = e => {
    //     setValueNegaraOpt(e)
    // }

    const handleClickResetSearch = () => {
        setValueSearchAju('')
        // setValueSearchEks('')
        // setValueNegaraOpt(null)
        // setValueStatusOpt(null)
        getListPpm(0, 10)
    }

    const reloadList = async (nomorAju, page, size) => {
        const _res = await transaksiService.listPpmPerUpt(nomorAju, null, localStorage.getItem('kdUnit'), '028', page, size)
        setListPpm(_res.data.data)
        setSize(size)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">No. Aju</Form.Label>
                                            <Col sm="9">
                                                <Form.Control type="searchNib" placeholder="Nomor Aju" className="form-control-sm" value={valueSearchAju} onChange={onChangeSearchAju} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                                {/* <div className="col-sm-6">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Eksportir</Form.Label>
                                            <Col sm="9">
                                                <Form.Control type="searchNib" placeholder="Nama Eksportir" className="form-control-sm" value={valueSearchEks} onChange={onChangeSearchEks}/>
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div> */}
                            </div>
                            {/* <div className="row">
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Status</Form.Label>
                                            <Col sm="9">
                                                <AsyncPaginate
                                                    loadOptions={loadOptionStatus}
                                                    value={valueStatusOpt}
                                                    getOptionValue={(option) => option.kodeStatus}
                                                    getOptionLabel={(option) => option.uraianStatus}
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                    onChange={onChangeStatus}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="col-sm-6">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Negara Tujuan</Form.Label>
                                            <Col sm="8">
                                                <AsyncPaginate
                                                    loadOptions={loadOptionNegara}
                                                    value={valueNegaraOpt}
                                                    getOptionValue={(option) => option.kodeNegara}
                                                    getOptionLabel={(option) => option.kodeNegara + ' - ' + option.uraianNegara}
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                    onChange={onChangeNegara}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari(0, 10)}>Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickResetSearch()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Permohonan Sertifikat Mutu dan Keamanan Hasil Perikanan </h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listPpm}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                    expandableRows
                                    expandOnRowDoubleClicked
                                    // expandableRowsComponent={ExpandableComponent}
                                    expandableRowsComponent={({ data }) => <ExpandableComponentTugas data={data} reloadList={reloadList} />}
                                    // expandableRowsHideExpander
                                    expandableIcon={{
                                        collapsed: <FaPlus size={12} color="blue" />, // Custom expand icon
                                        expanded: <FaMinus size={12} color="red" />,   // Custom collapse icon
                                    }}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ModalCetakPermohonan showCetak={showCetak} handleCloseCetak={handleCloseCetak} datappm={rowData} />
            <ModalLog showLog={showLog} handleCloseLog={handleCloseLog} datappm={rowData} />
            {
                showConfirmHapus &&
                <SweetAlert
                    title="Hapus Permohonan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingHapus ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Hapus...
                            </>
                        ) : (
                            "Hapus"
                        )
                    }
                    confirmBtnBsStyle="danger"
                    cancelBtnText="Kembali"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickHapus}
                    onCancel={handleCloseConfirmHapus}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                >
                    {loadingHapus && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Hapus data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showHapusSuccess &&
                <SweetAlert
                    success
                    title="Hapus Data Berhasil"
                    onConfirm={handleClickHapusSuccess}
                    btnSize="sm"
                />
            }
            {
                showHapusFailed &&
                <SweetAlert
                    danger
                    title="Hapus Data Gagal"
                    onConfirm={handleClickHapusFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    );
};


export default DaftarSetujuDraft;
